import { render, staticRenderFns } from "./DataLoad.vue?vue&type=template&id=7bbd0428&scoped=true&"
import script from "./DataLoad.vue?vue&type=script&lang=js&"
export * from "./DataLoad.vue?vue&type=script&lang=js&"
import style0 from "./DataLoad.vue?vue&type=style&index=0&id=7bbd0428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd0428",
  null
  
)

export default component.exports